import { render, staticRenderFns } from "./RepricingSpeed.vue?vue&type=template&id=484352d2&scoped=true"
import script from "./RepricingSpeed.vue?vue&type=script&lang=js"
export * from "./RepricingSpeed.vue?vue&type=script&lang=js"
import style0 from "./RepricingSpeed.vue?vue&type=style&index=0&id=484352d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484352d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
